import { Outlet, Link, useLocation } from "react-router-dom"
import parse from "html-react-parser"

function PageWithSupagesPreview(
    props: {
        page: any
    }
) {

  const location = useLocation();

  const activePage = location.pathname === `/${props.page.pageLink}`;

  return (
    <div
      className='w-full
                flex flex-col items-center justify-center'
    >
      <div
        className='w-[80%] h-full
                  flex flex-col items-center
                  pt-8'
      >
        {
          activePage && (
            <p
              className="font-bold text-4xl text-center"
            >
              {props.page.pageName}
            </p>
          )
        }
        {
          activePage && (
            <div
              className="w-full
                        mt-10
                        flex items-center justify-center"
            >
              <p
                className="font-medium text-xl"
              >
                Also explore the following:
              </p>
            </div>
          )
        }
        {
          activePage && (
            <div
              className="w-[100%] 
                        max-w-[100%] 
                        mt-10
                        sm:w-[100%]
                        sm:max-w-[100%] 
                        md:block sm:flex sm:flex-row sm:justify-center
                        mb-10"
            >
              {
                props.page.subPages.map((subpage: any, index: number)=> (
                  <Link
                    key={index}
                    to={`/${subpage.subPageLink}`}
                    className="p-1 pl-4 pr-4 mr-8 ml-8 mb-4 sm:mb-0
                            bg-[#054164]/0 hover:bg-[#054164]
                            text-[#054164] hover:text-white
                            text-xl font-semibold
                            border-[3px] border-[#054164]
                            rounded-xl float-left
                            md:w-[30%]
                            md:min-h-[30%]
                            md:h-[100px]
                            md:m-[16px]
                            text-ellipsis"
                  >
                    {subpage.subPageName}
                  </Link>
                ))
              }
            </div>
          )
        }
        {
          activePage && (
            <div
              className='w-[100%] h-fit
                        flex flex-col
                        pt-8 pb-8 '
            >
              {parse(props.page.pageContent)}
            </div>
          )
        }
        <Outlet />
      </div>
    </div>
  )
}

export default PageWithSupagesPreview